// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"41a7f8cb","249":"25472059","359":"73898f61","614":"9737dec2","663":"4682c089","737":"18ba46e1","938":"99bff364","971":"45921ea0"}[chunkId] + ".chunk.js";
};